import Platforms from 'constants/platforms';

export default class PlatformDetection {

    static get os() {
        if (!window.platformDetection) {
            PlatformDetection._detectPlatform();
        }
        return window.platformDetection.os;
    }

    static get browser() {
        if (!window.platformDetection) {
            PlatformDetection._detectPlatform();
        }
        return window.platformDetection.browser;
    }

    static _platform(name, isSupported) {
        return {
            name: name,
            isSupported: isSupported
        };
    }

    static _detectPlatform() {
        const userAgent = navigator.userAgent.toLowerCase();

        window.platformDetection = {
            os: PlatformDetection.detectOs(userAgent),
            browser: PlatformDetection.detectBrowser(userAgent)
        };
        // Sample usage:
        // console.log(window.platformDetection.os.name); // e.g.: win
        // console.log(window.platformDetection.os.isSupported);
        // console.log(window.platformDetection.browser.name); // e.g.: chrome
        // console.log(window.platformDetection.browser.isSupported);

    }

    static detectOs(userAgent) {

        // Windows Phone must come first because its UA also contains "Android"
        if (userAgent.indexOf('windows phone') !== -1) {
            return PlatformDetection._platform(Platforms.os.winPhone, false);
        }

        // Android
        if (userAgent.indexOf('android') !== -1) {
            return PlatformDetection._platform(Platforms.os.android, false);
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('iphone') !== -1
            || userAgent.indexOf('ipod') !== -1) {
            return PlatformDetection._platform(Platforms.os.ios, false);
        }

        if (userAgent.indexOf('mac os x') !== -1) {
            return PlatformDetection._platform(Platforms.os.mac, true);
        }

        return PlatformDetection._platform(Platforms.os.win, true);
    }

    static detectBrowser(userAgent) {

        // Many new browser's user agent contains "chrome". We parse the more specific agents first, and parse
        // the "real chrome" if no specific match was found.
        if (userAgent.indexOf('edge/') !== -1) {
            return PlatformDetection._platform(Platforms.browser.edge, true);
        }

        if (userAgent.indexOf('firefox/') !== -1) {
            return PlatformDetection._platform(Platforms.browser.firefox, true);
        }

        if (userAgent.indexOf('chrome/') !== -1) {
            return PlatformDetection._platform(Platforms.browser.chrome, true);
        }

        if (userAgent.indexOf('safari/') !== -1) {
            return PlatformDetection._platform(Platforms.browser.safari, true);
        }

        if (userAgent.indexOf('msie 8') !== -1) {
            return PlatformDetection._platform(Platforms.browser.ie8, false);
        }

        if (userAgent.indexOf('msie 9') !== -1) {
            return PlatformDetection._platform(Platforms.browser.ie9, false);
        }

        if (userAgent.indexOf('msie 10') !== -1) {
            return PlatformDetection._platform(Platforms.browser.ie10, true);
        }

        if ((userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1)
            && userAgent.indexOf('rv:11') !== -1) {
            return PlatformDetection._platform(Platforms.browser.ie11, true);
        }

        return PlatformDetection._platform(Platforms.browser.safari, true);
    }
}



/** WEBPACK FOOTER **
 ** ./src/infrastructure/platform-detection.js
 **/